import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { first } from 'rxjs/operators';
import { CataloguesService } from '../../../core/services/catalogues.service';
import { FormStatus, Tenant } from '../../../data/models';

@Component({
    selector: 'app-reassign-supplier-connection',
    templateUrl: './reassign-supplier-connection.component.html',
    standalone: false,
})
export class ReassignSupplierConnectionComponent {
    // @ts-ignore TS2564
    @Input() connections: string[];
    @Input() reassignTenants: Tenant[] = [];
    @Output() closemodal: EventEmitter<boolean> = new EventEmitter();
    hasSelectError = true;
    formStatus: FormStatus = FormStatus.Idle;
    formStatusEnum = FormStatus;
    formErrorMessage = null;
    // @ts-ignore TS2322
    selectedTenant: Tenant = null;

    selectTenantFocused = false;
    selectTenantHover = false;

    constructor(
        private cataloguesService: CataloguesService,
        private bsModalRef: BsModalRef
    ) {}

    cancel() {
        this.closemodal.emit(false);
        this.bsModalRef.hide();
    }

    updateTenant(item: Tenant) {
        this.selectedTenant = item;
        this.hasSelectError = this.selectedTenant === null;
    }

    reassignConnection() {
        this.hasSelectError = this.selectedTenant === null;

        if (this.hasSelectError) {
            this.formStatus = FormStatus.Error;
            // @ts-ignore TS2322
            this.formErrorMessage = 'Mandatory fields Please fix.';
        } else {
            this.formStatus = FormStatus.Saving;

            this.cataloguesService
                .reassignIntegrationConnections(this.connections, this.selectedTenant.tenantId)
                .pipe(first())
                .subscribe(
                    () => {
                        this.formStatus = FormStatus.Idle;
                        this.closemodal.emit(true);
                        this.bsModalRef.hide();
                    },
                    (err) => {
                        let error = 'Error reassigning connection(s).';
                        if (err?.graphQLErrors?.length > 0) {
                            if (err.graphQLErrors[0].message.startsWith('Target tenant is not an integration provider')) {
                                error = 'Selected location is not an integration provider.';
                            } else {
                                error = err.graphQLErrors[0].message;
                            }
                        }

                        this.formStatus = FormStatus.Error;
                        // @ts-ignore TS2322
                        this.formErrorMessage = error;
                    }
                );
        }
    }
}
